import { CreditDetailsView } from "@portal/BaseComponents/DetailsView/CreditsDetailView/CreditDetailView";
import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { CreditNotes } from "@portal/Components/Portal/PotalTabs/CreditNotes/CreditNotes";
import { useFormats } from "@portal/hooks/use-formats";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { Provider } from "jotai";
import { useParams } from "react-router-dom";

function CreditNotesPage() {
  const { credits_id } = useParams<AppPageParams>();
  const { extra } = useFormats();
  return (
    <>
      <Provider>
        {/* <CreditFilters /> */}
        <CreditNotes extra={extra} />{" "}
      </Provider>
      <CreditDetailsView id={credits_id} open={Boolean(credits_id)} />
      <InvoiceDetailsView />
    </>
  );
}

export { CreditNotesPage };
